// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__TGijS","subcontainer":"forgot-password_subcontainer__CGlIm"};